import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "font-bold text-white bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-left" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Score")
  ])
], -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "pr-5 text-right" }
const _hoisted_6 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Loading leaderboard...")

import { useFactionsStore } from '@/store/factions';
import { onMounted, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Image from '@/components/Scorecard/Image.vue';
import UserVue from '@/components/User/User.vue';
import { useUserStore } from '@/store/users';
import type { User } from '@/typings/user';
import { Scorecard, ScorecardStatus } from '@/typings/scorecard';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const store = useFactionsStore();
const userStore = useUserStore();
const { user } = toRefs(userStore);

const factionId = route.params.factionId as string;
const scorecardSlug = route.params.slug as string;

const plainScorecard = ref<Scorecard>();
onMounted(async () => {
  plainScorecard.value = await store.getFactionScorecard(
    factionId,
    scorecardSlug
  );
});

function openCard(user: User) {
  if (
    plainScorecard.value &&
    [
      ScorecardStatus.Locked,
      ScorecardStatus.Finalizing,
      ScorecardStatus.Closed,
    ].includes(plainScorecard.value.Status)
  )
    router.push({
      name: 'ScorecardUser',
      params: {
        user: user.Name,
        slug: scorecardSlug,
      },
    });
}

return (_ctx: any,_cache: any) => {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (plainScorecard.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(Image, { scorecard: plainScorecard.value }, null, 8, ["scorecard"]),
          _createElementVNode("table", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plainScorecard.value.Rankings, (rank) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass([
              'cursor-pointer hover:bg-gray-200',
              { 'bg-blue-200': rank.User.Uuid === _unref(user)?.Uuid },
            ]),
                  key: rank.User.Name,
                  onClick: ($event: any) => (openCard(rank.User))
                }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(rank.Rank), 1),
                  _createElementVNode("td", null, [
                    _createVNode(UserVue, {
                      user: rank.User
                    }, null, 8, ["user"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(rank.Score), 1)
                ], 10, _hoisted_4))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_Spinner, null, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]))
}
}

})